export const DRIVER_STATUS = [
  { text: 'ACTIVO', value: 'ACTIVO' },
  { text: 'INACTIVO', value: 'INACTIVO' },
  { text: 'RETIRADO', value: 'RETIRADO' }
];
